<template>
  <div>
    <van-button type="info" @click="IOSclient()">点击跳转ios下载页</van-button>
  </div>
</template>

<script>

export default {
  components: {},
  name: "example",
  data () {
    return {}
  },
  methods: {
    // 点击跳转IOS下载页
    IOSclient() {
      this.$router.push('/iosclient')
    },
  },
};
</script>

<style lang="scss" scoped>

</style>